// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   VIEW SHELL — estilo unificado de cabecera/tabs/divider/scroll
   ------------------------------------------------------------
   Fuente ÚNICA de verdad para el "shell" de las vistas con tabs.
   Referencia visual: vista Oportunidades (cards-real-estate).

   Se añade a \`styleUrls\` de cada componente (NO se importa global)
   para que herede la encapsulación Emulated del componente y las
   clases genéricas (.menu-options, .divider, .scrollable-container)
   no se filtren a otros sitios como el menú lateral.

   Solo desktop en esta pasada — los bloques @media móviles viven
   en el CSS propio de cada vista.
   ============================================================ */

/* ===== Variables de control del shell (ajústalas AQUÍ una sola vez
   para que cambie en TODAS las vistas con tabs a la vez) =====
   El margen superior total de los tabs = --view-shell-top-gap.
   (El padding-top del wrapper app-content-container NO se toca desde aquí:
   hacerlo con ::ng-deep se filtraba a vistas sin tabs como Oportunidades.) */
:root {
  --view-shell-top-gap: var(--spacing-2);      /* respiro arriba de los tabs (8px) */
  --view-shell-tabs-gap: var(--spacing-6);     /* separación tabs → línea divisoria (24px) */
}

/* Wrapper del componente que engloba el botón móvil + el content-container */
.view-shell-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

/* En desktop el .mobile-tab-nav (botón) no ocupa espacio */
.mobile-tab-nav {
  display: none;
}

/* En desktop el content-container ocupa todo */
.view-shell-wrapper > app-content-container {
  flex: 1 1 auto;
  min-height: 0;
}

.menu-investment {
  position: relative;
}

/* ---- Tabs (títulos) ---- */
.menu-options {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  padding: var(--view-shell-top-gap) 0 0 0;   /* respiro superior a los títulos */
  margin: 0 0 var(--view-shell-tabs-gap) 0;   /* separación antes de la línea divisoria */
  position: relative;
  overflow-x: auto;
  scrollbar-width: none;             /* Firefox */
}

.menu-options::-webkit-scrollbar {
  display: none;
}

/* Las pestañas pueden ser <p> o <a> según la vista → estilamos ambas
   igual para que TODAS las interfaces compartan tamaño/color/fuente. */
.menu-options p,
.menu-options a {
  /* Montserrat explícito (literal + token) para que NINGUNA regla heredada lo cambie */
  font-family: 'Montserrat', var(--font-family-primary), sans-serif !important;
  /* Tamaño FIJO (sin vw) → idéntico en todas las vistas, no depende del ancho */
  font-size: 1rem !important;        /* 16px */
  line-height: 1.2 !important;
  font-weight: var(--font-weight-semibold) !important;
  /* Títulos de tabs SIEMPRE negro puro, estén o no seleccionados (Figma #000000). */
  color: #000000 !important;
  cursor: pointer;
  transition: transform 0.3s ease, color 0.3s ease;
  text-align: center;
  text-decoration: none !important;
  margin: 0;
  padding: 5px 15px;
  white-space: nowrap;
  flex-shrink: 0;
}

.menu-options p.active,
.menu-options a.active {
  color: #000000 !important;
}

.menu-options p:hover,
.menu-options a:hover {
  color: var(--color-primary) !important;
  transform: scale(1.05);
}

/* ---- Línea divisoria + indicador ---- */
.divider {
  position: relative;
  width: 100%;
  height: 4px;
  background-color: var(--color-border-light);
  overflow: hidden;
  margin: 0 0 var(--spacing-6) 0;    /* 24px entre la línea y el contenido */
}

.divider-section {
  position: absolute;
  height: 100%;
  background-color: var(--color-primary);
  transition: width 0.3s ease, left 0.3s ease;
  bottom: 0;
}

/* ---- Contenedor scrolleable ---- */
.scrollable-container {
  flex: 1 1 0;
  min-height: 0;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: var(--color-primary) transparent;
  padding-bottom: var(--spacing-8);
  /* Separar el scrollbar del contenido: el padding empuja el texto a la
     izquierda y el scrollbar queda más a la derecha, sin pegarse al contenido. */
  padding-right: var(--spacing-4);
  -webkit-overflow-scrolling: touch;
}

.scrollable-container::-webkit-scrollbar {
  width: 8px;
}

.scrollable-container::-webkit-scrollbar-track {
  background: transparent;
}

.scrollable-container::-webkit-scrollbar-thumb {
  background: var(--color-primary);
  border-radius: 8px;
}

.scrollable-container::-webkit-scrollbar-thumb:hover {
  background: var(--color-primary-hover);
}

/* ---- Padding del wrapper con el menú lateral colapsado ----
   Solo se activa con la clase .menu-collapsed que cada vista ya
   añade sobre <app-content-container [class.menu-collapsed]>. */
.backgroundWhite.menu-collapsed,
:host ::ng-deep app-content-container > .content-container.menu-collapsed {
  width: 100% !important;
  padding: var(--spacing-10) var(--spacing-16) 0 var(--spacing-16) !important;
  transition: padding 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.backgroundWhite.menu-collapsed .menu-options {
  justify-content: space-around !important;
  gap: 0 !important;
  width: 100% !important;
}

@media screen and (max-width: 1324px) {
  .backgroundWhite.menu-collapsed,
  :host ::ng-deep app-content-container > .content-container.menu-collapsed {
    padding: var(--spacing-10) var(--spacing-10) 0 var(--spacing-10) !important;
  }
}

/* ============================================================
   MÓVIL — Dropdown de tabs unificado (patrón del detalle de proyecto)
   En móvil los tabs se ocultan y aparece un botón naranja con el label
   del tab activo; al pulsarlo se despliega un panel con las opciones en
   píldoras (blanca = inactiva, naranja = activa).
   ============================================================ */

/* Botón naranja: oculto en desktop, visible en móvil. */
.mobile-tab-button {
  display: none;
}

@media screen and (max-width: 767px) {
  /* En móvil el wrapper se gestiona diferente */
  .view-shell-wrapper {
    height: auto;
    min-height: 100%;
  }

  /* Mostrar el bloque de navegación móvil */
  .mobile-tab-nav {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 12px 16px 0;
    position: relative;
    background: white;
  }

  /* Botón disparador */
  .mobile-tab-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    /* Ancho completo (menos el padding 16px del .mobile-tab-nav) para que
       coincida exactamente con el recuadro del saldo del content-container,
       que también respeta 16px lateral. Sin max-width que lo estreche. */
    width: 100%;
    margin: 0;
    padding: 12px 16px;
    background: var(--color-primary-light);   /* naranja relleno */
    color: var(--color-white);
    border: none;
    border-radius: 12px;
    font-family: 'Montserrat', sans-serif;
    font-size: 0.95rem;
    font-weight: var(--font-weight-semibold);
    text-transform: uppercase;
    cursor: pointer;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.08);
    transition: background 0.2s ease;
  }

  .mobile-tab-button:hover {
    background: var(--color-primary);
  }

  .mobile-tab-button .mobile-tab-chevron {
    transition: transform 0.3s ease;
  }

  .mobile-tab-button .mobile-tab-chevron.rotated {
    transform: rotate(180deg);
  }

  /* Ocultar TODOS los .menu-investment que NO sean el del dropdown móvil.
     Cubre: dentro de app-content-container y directamente en view-shell-wrapper. */
  .view-shell-wrapper > app-content-container .menu-investment,
  .view-shell-wrapper > .menu-investment {
    display: none !important;
  }

  /* El panel dropdown del mobile-tab-nav */
  .mobile-tab-nav .menu-investment {
    display: none;
    position: absolute;
    top: 100%;
    left: 16px;
    right: 16px;
    z-index: 50;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    width: auto;
    margin-top: 8px;
    padding: 16px 8px;
    background: var(--color-gray-100);
    border-radius: 16px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
    box-sizing: border-box;
  }

  .mobile-tab-nav .menu-investment.mobile-open {
    display: flex;
  }

  /* Tabs en columna como píldoras. */
  .menu-investment .menu-options {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    padding: 0;
    width: 100%;
    margin: 0;
    overflow: visible;
  }

  .menu-investment .menu-options p,
  .menu-investment .menu-options a {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 12px;
    border-radius: 12px;
    background: var(--color-white);
    color: var(--color-black) !important;
    font-size: 14px !important;
    font-weight: var(--font-weight-semibold) !important;
    text-align: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  }

  .menu-investment .menu-options p:hover,
  .menu-investment .menu-options a:hover {
    background: #fef1e5;
    transform: none;
  }

  /* Píldora activa en naranja. */
  .menu-investment .menu-options p.active,
  .menu-investment .menu-options a.active {
    background: var(--color-primary-light);
    color: var(--color-white) !important;
    font-weight: var(--font-weight-bold) !important;
    box-shadow: 0 4px 10px rgba(255, 150, 0, 0.3);
  }

  /* La línea divisoria no se muestra en el dropdown. */
  .menu-investment .divider {
    display: none;
  }

  /* Wrapper relativo para posicionar el panel flotante respecto al botón. */
  .mobile-tab-nav {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/styles/view-shell.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;iEAaiE;;AAEjE;;;;6EAI6E;AAC7E;EACE,sCAAsC,OAAO,qCAAqC;EAClF,uCAAuC,MAAM,6CAA6C;AAC5F;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA,2DAA2D;AAC3D;EACE,aAAa;AACf;;AAEA,+CAA+C;AAC/C;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,wCAAwC,IAAI,mCAAmC;EAC/E,wCAAwC,IAAI,2CAA2C;EACvF,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB,cAAc,YAAY;AACjD;;AAEA;EACE,aAAa;AACf;;AAEA;uEACuE;AACvE;;EAEE,qFAAqF;EACrF,4EAA4E;EAC5E,8EAA8E;EAC9E,0BAA0B,SAAS,SAAS;EAC5C,2BAA2B;EAC3B,mDAAmD;EACnD,kFAAkF;EAClF,yBAAyB;EACzB,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,gCAAgC;EAChC,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,2CAA2C;EAC3C,gBAAgB;EAChB,8BAA8B,KAAK,uCAAuC;AAC5E;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sCAAsC;EACtC,2CAA2C;EAC3C,SAAS;AACX;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,iDAAiD;EACjD,gCAAgC;EAChC;iFAC+E;EAC/E,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;gEAEgE;AAChE;;EAEE,sBAAsB;EACtB,2EAA2E;EAC3E,qDAAqD;AACvD;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE;;IAEE,2EAA2E;EAC7E;AACF;;AAEA;;;;;iEAKiE;;AAEjE,wDAAwD;AACxD;EACE,aAAa;AACf;;AAEA;EACE,8CAA8C;EAC9C;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA,0CAA0C;EAC1C;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA,qBAAqB;EACrB;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR;;yEAEqE;IACrE,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,sCAAsC,IAAI,oBAAoB;IAC9D,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,qCAAqC;IACrC,kBAAkB;IAClB,wCAAwC;IACxC,yBAAyB;IACzB,eAAe;IACf,yCAAyC;IACzC,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;mFACiF;EACjF;;IAEE,wBAAwB;EAC1B;;EAEA,yCAAyC;EACzC;IACE,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,iCAAiC;IACjC,mBAAmB;IACnB,2CAA2C;IAC3C,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA,mCAAmC;EACnC;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,UAAU;IACV,WAAW;IACX,SAAS;IACT,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oCAAoC;IACpC,0BAA0B;IAC1B,mDAAmD;IACnD,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;;IAEE,mBAAmB;IACnB,eAAe;EACjB;;EAEA,+BAA+B;EAC/B;;IAEE,sCAAsC;IACtC,oCAAoC;IACpC,+CAA+C;IAC/C,6CAA6C;EAC/C;;EAEA,qDAAqD;EACrD;IACE,aAAa;EACf;;EAEA,0EAA0E;EAC1E;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;AACF","sourcesContent":["/* ============================================================\n   VIEW SHELL — estilo unificado de cabecera/tabs/divider/scroll\n   ------------------------------------------------------------\n   Fuente ÚNICA de verdad para el \"shell\" de las vistas con tabs.\n   Referencia visual: vista Oportunidades (cards-real-estate).\n\n   Se añade a `styleUrls` de cada componente (NO se importa global)\n   para que herede la encapsulación Emulated del componente y las\n   clases genéricas (.menu-options, .divider, .scrollable-container)\n   no se filtren a otros sitios como el menú lateral.\n\n   Solo desktop en esta pasada — los bloques @media móviles viven\n   en el CSS propio de cada vista.\n   ============================================================ */\n\n/* ===== Variables de control del shell (ajústalas AQUÍ una sola vez\n   para que cambie en TODAS las vistas con tabs a la vez) =====\n   El margen superior total de los tabs = --view-shell-top-gap.\n   (El padding-top del wrapper app-content-container NO se toca desde aquí:\n   hacerlo con ::ng-deep se filtraba a vistas sin tabs como Oportunidades.) */\n:root {\n  --view-shell-top-gap: var(--spacing-2);      /* respiro arriba de los tabs (8px) */\n  --view-shell-tabs-gap: var(--spacing-6);     /* separación tabs → línea divisoria (24px) */\n}\n\n/* Wrapper del componente que engloba el botón móvil + el content-container */\n.view-shell-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n}\n\n/* En desktop el .mobile-tab-nav (botón) no ocupa espacio */\n.mobile-tab-nav {\n  display: none;\n}\n\n/* En desktop el content-container ocupa todo */\n.view-shell-wrapper > app-content-container {\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.menu-investment {\n  position: relative;\n}\n\n/* ---- Tabs (títulos) ---- */\n.menu-options {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  width: 100%;\n  padding: var(--view-shell-top-gap) 0 0 0;   /* respiro superior a los títulos */\n  margin: 0 0 var(--view-shell-tabs-gap) 0;   /* separación antes de la línea divisoria */\n  position: relative;\n  overflow-x: auto;\n  scrollbar-width: none;             /* Firefox */\n}\n\n.menu-options::-webkit-scrollbar {\n  display: none;\n}\n\n/* Las pestañas pueden ser <p> o <a> según la vista → estilamos ambas\n   igual para que TODAS las interfaces compartan tamaño/color/fuente. */\n.menu-options p,\n.menu-options a {\n  /* Montserrat explícito (literal + token) para que NINGUNA regla heredada lo cambie */\n  font-family: 'Montserrat', var(--font-family-primary), sans-serif !important;\n  /* Tamaño FIJO (sin vw) → idéntico en todas las vistas, no depende del ancho */\n  font-size: 1rem !important;        /* 16px */\n  line-height: 1.2 !important;\n  font-weight: var(--font-weight-semibold) !important;\n  /* Títulos de tabs SIEMPRE negro puro, estén o no seleccionados (Figma #000000). */\n  color: #000000 !important;\n  cursor: pointer;\n  transition: transform 0.3s ease, color 0.3s ease;\n  text-align: center;\n  text-decoration: none !important;\n  margin: 0;\n  padding: 5px 15px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.menu-options p.active,\n.menu-options a.active {\n  color: #000000 !important;\n}\n\n.menu-options p:hover,\n.menu-options a:hover {\n  color: var(--color-primary) !important;\n  transform: scale(1.05);\n}\n\n/* ---- Línea divisoria + indicador ---- */\n.divider {\n  position: relative;\n  width: 100%;\n  height: 4px;\n  background-color: var(--color-border-light);\n  overflow: hidden;\n  margin: 0 0 var(--spacing-6) 0;    /* 24px entre la línea y el contenido */\n}\n\n.divider-section {\n  position: absolute;\n  height: 100%;\n  background-color: var(--color-primary);\n  transition: width 0.3s ease, left 0.3s ease;\n  bottom: 0;\n}\n\n/* ---- Contenedor scrolleable ---- */\n.scrollable-container {\n  flex: 1 1 0;\n  min-height: 0;\n  width: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: var(--color-primary) transparent;\n  padding-bottom: var(--spacing-8);\n  /* Separar el scrollbar del contenido: el padding empuja el texto a la\n     izquierda y el scrollbar queda más a la derecha, sin pegarse al contenido. */\n  padding-right: var(--spacing-4);\n  -webkit-overflow-scrolling: touch;\n}\n\n.scrollable-container::-webkit-scrollbar {\n  width: 8px;\n}\n\n.scrollable-container::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.scrollable-container::-webkit-scrollbar-thumb {\n  background: var(--color-primary);\n  border-radius: 8px;\n}\n\n.scrollable-container::-webkit-scrollbar-thumb:hover {\n  background: var(--color-primary-hover);\n}\n\n/* ---- Padding del wrapper con el menú lateral colapsado ----\n   Solo se activa con la clase .menu-collapsed que cada vista ya\n   añade sobre <app-content-container [class.menu-collapsed]>. */\n.backgroundWhite.menu-collapsed,\n:host ::ng-deep app-content-container > .content-container.menu-collapsed {\n  width: 100% !important;\n  padding: var(--spacing-10) var(--spacing-16) 0 var(--spacing-16) !important;\n  transition: padding 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.backgroundWhite.menu-collapsed .menu-options {\n  justify-content: space-around !important;\n  gap: 0 !important;\n  width: 100% !important;\n}\n\n@media screen and (max-width: 1324px) {\n  .backgroundWhite.menu-collapsed,\n  :host ::ng-deep app-content-container > .content-container.menu-collapsed {\n    padding: var(--spacing-10) var(--spacing-10) 0 var(--spacing-10) !important;\n  }\n}\n\n/* ============================================================\n   MÓVIL — Dropdown de tabs unificado (patrón del detalle de proyecto)\n   En móvil los tabs se ocultan y aparece un botón naranja con el label\n   del tab activo; al pulsarlo se despliega un panel con las opciones en\n   píldoras (blanca = inactiva, naranja = activa).\n   ============================================================ */\n\n/* Botón naranja: oculto en desktop, visible en móvil. */\n.mobile-tab-button {\n  display: none;\n}\n\n@media screen and (max-width: 767px) {\n  /* En móvil el wrapper se gestiona diferente */\n  .view-shell-wrapper {\n    height: auto;\n    min-height: 100%;\n  }\n\n  /* Mostrar el bloque de navegación móvil */\n  .mobile-tab-nav {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    padding: 12px 16px 0;\n    position: relative;\n    background: white;\n  }\n\n  /* Botón disparador */\n  .mobile-tab-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    /* Ancho completo (menos el padding 16px del .mobile-tab-nav) para que\n       coincida exactamente con el recuadro del saldo del content-container,\n       que también respeta 16px lateral. Sin max-width que lo estreche. */\n    width: 100%;\n    margin: 0;\n    padding: 12px 16px;\n    background: var(--color-primary-light);   /* naranja relleno */\n    color: var(--color-white);\n    border: none;\n    border-radius: 12px;\n    font-family: 'Montserrat', sans-serif;\n    font-size: 0.95rem;\n    font-weight: var(--font-weight-semibold);\n    text-transform: uppercase;\n    cursor: pointer;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.08);\n    transition: background 0.2s ease;\n  }\n\n  .mobile-tab-button:hover {\n    background: var(--color-primary);\n  }\n\n  .mobile-tab-button .mobile-tab-chevron {\n    transition: transform 0.3s ease;\n  }\n\n  .mobile-tab-button .mobile-tab-chevron.rotated {\n    transform: rotate(180deg);\n  }\n\n  /* Ocultar TODOS los .menu-investment que NO sean el del dropdown móvil.\n     Cubre: dentro de app-content-container y directamente en view-shell-wrapper. */\n  .view-shell-wrapper > app-content-container .menu-investment,\n  .view-shell-wrapper > .menu-investment {\n    display: none !important;\n  }\n\n  /* El panel dropdown del mobile-tab-nav */\n  .mobile-tab-nav .menu-investment {\n    display: none;\n    position: absolute;\n    top: 100%;\n    left: 16px;\n    right: 16px;\n    z-index: 50;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    width: auto;\n    margin-top: 8px;\n    padding: 16px 8px;\n    background: var(--color-gray-100);\n    border-radius: 16px;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n    box-sizing: border-box;\n  }\n\n  .mobile-tab-nav .menu-investment.mobile-open {\n    display: flex;\n  }\n\n  /* Tabs en columna como píldoras. */\n  .menu-investment .menu-options {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n    padding: 0;\n    width: 100%;\n    margin: 0;\n    overflow: visible;\n  }\n\n  .menu-investment .menu-options p,\n  .menu-investment .menu-options a {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    padding: 12px;\n    border-radius: 12px;\n    background: var(--color-white);\n    color: var(--color-black) !important;\n    font-size: 14px !important;\n    font-weight: var(--font-weight-semibold) !important;\n    text-align: center;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);\n  }\n\n  .menu-investment .menu-options p:hover,\n  .menu-investment .menu-options a:hover {\n    background: #fef1e5;\n    transform: none;\n  }\n\n  /* Píldora activa en naranja. */\n  .menu-investment .menu-options p.active,\n  .menu-investment .menu-options a.active {\n    background: var(--color-primary-light);\n    color: var(--color-white) !important;\n    font-weight: var(--font-weight-bold) !important;\n    box-shadow: 0 4px 10px rgba(255, 150, 0, 0.3);\n  }\n\n  /* La línea divisoria no se muestra en el dropdown. */\n  .menu-investment .divider {\n    display: none;\n  }\n\n  /* Wrapper relativo para posicionar el panel flotante respecto al botón. */\n  .mobile-tab-nav {\n    position: relative;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
